export default "__VITE_ASSET__CXo4f$TC__"